import React, { Component } from 'react'
import GenerateTemplate from '../actions/GenerateTemplate'
import PropTypes from 'prop-types'
import ChangeOnHoldState from '../actions/ChangeOnHoldState'
import MarkAsDone from '../actions/MarkAsDone'
import { Dropdown, Menu, Modal } from 'antd'
import CancelOrderItem from '../actions/CancelOrderItem'
import syncFulfillDesign from '../actions/syncFulfillDesign'
import RequestUpdateModal from "../actions/request-update/RequestUpdateModal"
import { getLocalData } from "../../../../../services/StorageServices"
import { getUserPermissions } from "../../../../../services/AuthServices"
import LazyLoad from 'react-lazyload'
import { checkDisallowRequestUpdate } from '../../../helpers/checkDisallowRequestUpdate'
import { parseJwt } from '../../../../../helpers/parseToken'

const allow3DStatuses = ['shipped', 'completed']

class OrderActions extends Component {
    state = {
        action: '',
    }

    _renderAction = () => {
        const { orderId, itemNumber, marketplace, onChangeStatus, onFetchOrders, namespace, type, brand } = this.props
        const orderTemplate = `${marketplace}_${itemNumber}`

        switch (this.state.action) {
            case 'request-update':
                if (checkDisallowRequestUpdate(namespace, type)) {
                    Modal.warning({
                        title: `Yêu cầu cập nhật design - #${orderTemplate}`,
                        content: <div className='text-danger font-weight-bold'>Vui lòng liên hệ designer!</div>,
                        onOk: this._resetAction,
                        okText: 'Đóng',
                    })
                    return
                }
                return <RequestUpdateModal
                    namespace={namespace}
                    title="Yêu cầu cập nhật design"
                    value='design'
                    onFetchOrders={onFetchOrders}
                    orderTemplate={orderTemplate}
                    onResetAction={this._resetAction}
                    type={type}
                    brand={brand}
                />
            case 'cancel-order':
                return <CancelOrderItem
                    onFetchOrders={onFetchOrders}
                    onResetAction={this._resetAction}
                    orderId={orderId}
                    orderTemplate={orderTemplate}
                    onChangeStatus={onChangeStatus}
                />
            default:
                return ''
        }
    }

    _handleClick = ({ key }) => {
        const { orderId, marketplace, itemNumber, onFetchOrders } = this.props
        const orderTemplate = `${marketplace}_${itemNumber}`

        if ('sync-fulfill-design' === key) {
            syncFulfillDesign(orderId, orderTemplate, onFetchOrders)
        }

        this.setState({
            action: key,
        })
    }

    _resetAction = () => {
        this.setState({
            action: '',
        })
    }

    _showSubMenu = () => {
        const { productionStatus, haveStatus, cancelStatus, tags } = this.props
        const user = getUserPermissions()

        return (
            <Menu onClick={this._handleClick}>
                {
                    !(haveStatus || cancelStatus) &&
                    <Menu.Item key='sync-fulfill-design'>Đồng bộ designs fulfillment</Menu.Item>
                }

                {
                    !allow3DStatuses.includes(productionStatus) && (!tags || !tags.includes('waiting-update-design')) &&
                    (user.hasOwnProperty('request_update') || user.hasOwnProperty('fac_request_update')) &&
                    <Menu.Item key='request-update'>Request update</Menu.Item>
                }

                {
                    !(haveStatus || cancelStatus) &&
                    <Menu.Item key='cancel-order' className='text-danger'>Hủy đơn</Menu.Item>
                }

            </Menu>
        )
    }

    _checkShowMenuActions = () => {
        const actions = []
        const { productionStatus, haveStatus, cancelStatus, tags } = this.props
        const user = getUserPermissions()

        if (!(haveStatus || cancelStatus)) {
            actions.push('syncAndCancel')
        }

        if (!allow3DStatuses.includes(productionStatus) && (!tags || !tags.includes('waiting-update-design')) && (user.hasOwnProperty('request_update') || user.hasOwnProperty('fac_request_update'))) {
            actions.push('request')
        }

        return actions
    }


    render() {
        const { orderId, status, onChangeStatus, haveStatus, cancelStatus } = this.props
        const action = this._renderAction()
        const showMenus = this._checkShowMenuActions()

        const tokenInfo = parseJwt(getLocalData('accessToken'))
        const { roles: userRoles = [] } = tokenInfo || {}

        const canOnHold = userRoles.some(item => ['Super Admin', 'fac_admin', 'fac_ffm'].includes(item.name))

        return (
            <div className='OrderActions'>
                <LazyLoad>

                    <div className={`Actions mb-3  ${(haveStatus || cancelStatus) && 'disableAction'}`}>
                        <MarkAsDone orderId={orderId} onSuccess={onChangeStatus} />
                        <GenerateTemplate orderId={orderId} onChangeStatus={onChangeStatus} />
                        {!!canOnHold &&
                            <ChangeOnHoldState orderId={orderId} status={status} onChangeStatus={onChangeStatus} />
                        }
                    </div>

                    {
                        !!showMenus && showMenus.length > 0 &&
                        <div className='MoreActions'>
                            <Dropdown overlay={this._showSubMenu} trigger={['click']}>
                                <span className='Icon'><i className='fa fa-ellipsis-h' /></span>
                            </Dropdown>

                            {action}
                        </div>
                    }
                </LazyLoad>

            </div>
        )
    }
}

OrderActions.defaultProps = {
    isPrinted: false,
}

OrderActions.propTypes = {
    namespace: PropTypes.string,
    tags: PropTypes.array,
    orderId: PropTypes.string.isRequired,
    isPrinted: PropTypes.bool.isRequired,
    status: PropTypes.string.isRequired,
    marketplace: PropTypes.string.isRequired,
    itemNumber: PropTypes.number.isRequired,
    productionStatus: PropTypes.string.isRequired,
    onChangeStatus: PropTypes.func.isRequired,
    onFetchOrders: PropTypes.func.isRequired,
}

export default OrderActions
